import * as React from 'react';
import {useEffect} from 'react';
import careStore from "../../store/careStore";
import {relative} from 'path';
import SelfCheck from './SelfCheck';
import Top from "../Top";
import Bottom from "../Bottom";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import {useTheme} from '@mui/material/styles';
import MobileStepper from '@mui/material/MobileStepper';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import Stack from '@mui/material/Stack';
import {useLocation} from "react-router-dom";
import { selfQuestionnaires } from "../../utils/selfQuestionnaires";
import checkStore from "../../store/checkStore";

const CheckStep = () => {
  const storeData: any = checkStore();
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set<number>());
  const [completed, setCompleted] = React.useState<{
    [k: number]: boolean;
  }>({});
  const {state} = useLocation();
  const {selfQuestionNo} = state;
  const [questionAskCount, setQuestionAskCount] = React.useState(0);
  const steps = new Array(selfQuestionnaires.filter((item: any) => item.no === selfQuestionNo)[0].questions.length - 1);

  useEffect(() => {
    setQuestionAskCount(selfQuestionnaires.filter((item: any) => item.no === selfQuestionNo)[0].questions.length - 1);

    return () => {
      storeData.setSelectedAnswerList([]);
    }
  }, []);

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };
 
  const handleNext = () => {
    if(storeData.selectedAnswerList.filter((v: any) => v.askNo === activeStep).length <= 0){ 
      alert('답변을 선택해주세요.');
    }else{
      let newSkipped = skipped;
  
      if (isStepSkipped(activeStep)) {
        newSkipped = new Set(newSkipped.values());
        newSkipped.delete(activeStep);
      }
  
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setSkipped(newSkipped);
    }
  };

  const handleBack = () => {
    // 백버튼 누르기전에 항목을 선택했었다면 선택한 값 삭제 처리
    let tempList = storeData.selectedAnswerList;
    storeData.setSelectedAnswerList(tempList.filter((v: any) => v.askNo < activeStep - 1));
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const drawStepContent = (activeStep: number) => {
    return (
      <SelfCheck
        key={activeStep}
        selfQuestionNo={selfQuestionnaires.filter((item: any) => item.no === selfQuestionNo)[0].no}
        resultType={selfQuestionnaires.filter((item: any) => item.no === selfQuestionNo)[0].resultType}
        item={selfQuestionnaires.filter((item: any) => item.no === selfQuestionNo)[0].questions[activeStep]}
        questionTotalCount={selfQuestionnaires.filter((item: any) => item.no === selfQuestionNo)[0].questions.length}
      />
    )
  };
  
  

  return (
    <Stack sx={{ width: '100%', minWidth: 320, background: '#F1F2F4' }} spacing={2}>
      <Top title={selfQuestionnaires.filter((item: any) => item.no === selfQuestionNo)[0].title} />

      <Box sx={{ position: 'relative', mt: '60px !important' }}>

        <Box sx={{ bgcolor: '#FFFBF8', p: 1, pl: 2, pr: 2 }}>
          <Typography component="div" sx={{ fontSize: 13, pb: 0, color: '#333', mb: 0, }}>
            {selfQuestionnaires.filter((item: any) => item.no === selfQuestionNo)[0].desc}
          </Typography>
        </Box>

        <Box sx={{ p: 2,pt:3, pb:1 }}>

          <MobileStepper
            variant="progress"
            steps={steps.length + 1}
            position="static"
            activeStep={activeStep}
            sx={{
              width: '100%', flexGrow: 1, p: 0, bgcolor: '#F1F2F4', boxSizing: 'border-box',
              '& .MuiLinearProgress-root': { width: '100%', bgcolor: '#fff', },
              '& .MuiLinearProgress-barColorPrimary': { bgcolor: '#EF8322' }
            }}
            nextButton={
              <Button size="small" onClick={handleNext} disabled={activeStep === questionAskCount} sx={{ display: 'none' }}>
                Next
              </Button>
            }
            backButton={
              <Button size="small" onClick={handleBack} disabled={activeStep === 0} sx={{ display: 'none' }}>
                Back
              </Button>
            }
          />

          <Typography sx={{ textAlign: 'right', fontSize: 12, color: '#777', mt: .5 }}><span style={{ fontWeight: 700, color: '#555' }}>{activeStep + 1}</span> / {steps.length + 1} </Typography>
        </Box>

        <Box>
          {(drawStepContent(activeStep))}
        </Box>

        <MobileStepper
          variant="progress"
          steps={steps.length + 1}
          position="static"
          activeStep={activeStep}
          sx={{
            width: '100%', flexGrow: 1, p: '0 20px 0px 20px', mb: 10, mt: 3, bgcolor: '#eeeff1', boxSizing: 'border-box',
            '& .MuiLinearProgress-root': { display: 'none' }
          }}
          nextButton={
            <Button size="small" onClick={handleNext} disabled={activeStep === questionAskCount} sx={stepNextBtn}>
              Next
              {theme.direction === 'rtl' ? (
                <KeyboardArrowLeft />
              ) : (
                <KeyboardArrowRight />
              )}
            </Button>
          }
          backButton={
            <Button size="small" onClick={handleBack} disabled={activeStep === 0} sx={stepBackBtn}>
              {theme.direction === 'rtl' ? (
                <KeyboardArrowRight />
              ) : (
                <KeyboardArrowLeft />
              )}
              Back
            </Button>
          }
        />
      </Box>
      <Bottom />
    </Stack >
  );
}

const stepBackBtn = {
  bgcolor: '#fff',
    color: '#ef8322',
  
  borderRadius: '30px 0 0 30px',
  border: '1px solid #ef8322',
  width: '48%',
  p: '10px',
  '&.MuiButtonBase-root:hover': {
     bgcolor: '#fff',
  color: '#ef8322',
  },
  '&.Mui-disabled': {
    border: '1px solid #ccc',
    bgcolor: '#f5f5f5',
  }
}

const stepNextBtn = {
  bgcolor: '#fff ',
  color: '#ef8322',
  borderRadius: '0 30px 30px 0 ',
  border: '1px solid #ef8322',
  width: '48%',
  p: '10px',
  '&.MuiButtonBase-root:hover': {
  
    bgcolor: '#fff ',
    color: '#ef8322',
  },
  '&.Mui-disabled': {
    border: '1px solid #ccc',
    bgcolor: '#f5f5f5',
  }
}

export default CheckStep;